<template>
  <div>
    <div id="foot">
      <div class="banxin">
        <div class="hezuohuoban">
          <img src="/static/img/hezuohuoban.png"/>
        </div>
        <div>
          <a href="javascript:void(0);" target="_blank">
            <img src="/static/img/logo_new.png">

          </a>
        </div>
  
        <div >
          <p>友情链接：<a target="_blank" href="http://www.kuaidi100.com">快递查询</a></p>
        </div>
        <p>JET EXPRESS GROUP PTY LTD&nbsp;&nbsp;
          地址：5/21 Amour St Revesby NSW 2212&nbsp;&nbsp;
          电话:  (+61)456 386 888
        </p>
        <p class="banquan"><a target="_blank"
          href="http://www.miitbeian.gov.cn">备案号:蜀ICP备15019828号-4</a>  &nbsp;©2000-2019 (jetexpressgroup.com). Some Rights Reserved
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {};
</script>
<style rel="stylesheet/scss" lang="scss">
  #foot .banxin .hezuohuoban {
    width: 1200px;
    height: 60px;
    margin-top: 90px;
    margin-bottom: 90px;
  }
  
  #foot .banxin p {
    font-size: 14px;
    text-align: center;
    color: #333333;
    margin-bottom: 8px;
  }
  
  #foot .banxin .banquan {
    margin-bottom: 16px;
  }
</style>


// WEBPACK FOOTER //
// src/views/layout/Footer.vue